<template>
  <div style="margin-left: 0px">
    <div style="z-index:-1">
      <img src="../../assets/images/background.png" style="width: 100%;height: 100vh;">
    </div>
    <div style="" class="form">
      <div class="loginTxt"> 登录</div>
      <div>
        <input v-model="userName" placeholder="请输入用户名" class="us">
        <input v-model="password" type="password" placeholder="请输入密码" class="pa">
      </div>
      <div>
        <button class="btn" @click="getData">登录</button>
      </div>
    </div>
  </div>
</template>

<script>
import { login } from '../../api/api'
import md5 from 'js-md5'
import axios from 'axios'
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
export default {
  data() {
    return {
      userName: '',
      password: ''
    }
  },
  created() {
  },
  methods: {
    // 登录
    submit() {
      // console.log('账号：', this.userName, '密码:', md5(this.password))
      // const formData = new FormData()
      // formData.append('client_id', 'admin')
      // formData.append('client_secret', '123456')
      // formData.append('scope', 'all')
      // formData.append('grant_type', 'password')

      // formData.append('account', this.userName)
      // formData.append('password', md5(this.password))
      // client_id=admin&client_secret=123456&scope=all&grant_type=password

      // const params = {}
      // params.acount = this.userName
      // params.password = md5(this.password)
      // console.log('提交', formData)
      // login(formData).then(res => {
      //   console.log('成功')
      //   if (res.msg == 'Success') { //输入正确
      //     this.$router.push('/ClickFeature')
      //   }
      // })
      // this.$axios({
      //   method: 'post',
      //   url: 'https://tzmap.tzyuansheng.com',
      //   headers: {
      //     'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      //   },
      //   data: { imgFile: url },
      //   params: { imgFile: params }
      // }).then(data => {
      //   console.log(data)
      // })
    },
    getData() {
      console.log('请求头：', axios.defaults.headers['Content-Type'])
      var api = 'https://tzmap.tzyuansheng.com/api/oauth/Login?client_id=admin&client_secret=123456&scope=all&grant_type=password'
      const formData = new URLSearchParams()
      formData.append('account', this.userName)
      formData.append('password', md5(this.password))
      console.log(formData.get('account'))
      // 使用post发送请求
      axios({
        url: api,
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          //     'Content-Type': 'multipart/form-data'
        },
        data: formData
      }).then(result => {
        console.log(result)

        if (result.data.msg == 'Success') { // 输入正确
          this.$router.push('/ClickFeature')
        } else {
          alert('登录失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.loginTxt {
  color: #1487CB;
  font-size: 46px;
  font-weight: 400;
  margin-top: 5vh;
}

.form {
  position: absolute;
  margin-top: -78vh;
  margin-left: 50vw;
  /*border: 1px solid red;*/
  width: 30vw;
  height: 50vh;
}
.us{
  padding-left: 30px;              /*设置内边距防止遮盖住图片*/
  height: 36px;             /*input高度*/
  width: 20vw;                  /*input宽度*/
  background-image: url("../../assets/user.png") ;/*设置图片的地址*/
  background-size:25px 25px;    /*这里是图片的大小*/
  background-repeat:no-repeat ;  /*让图片不重复*/
  background-position: 2vw 5px; /*图片在input中的位置  离左边的距离和离右边的距离*/
  /*border: none;*/
  background-color: rgb(245, 248, 255);
  border-radius: 20px;  /*设置圆角半径*/
  border: 1px solid rgb(245, 248, 255);
  /*去除点击产生的黑框*/
  outline: none;
padding-left: calc(4vw + 15px);
  margin-top: 5vh;
}
.pa{
  padding-left: 30px;              /*设置内边距防止遮盖住图片*/
  height: 36px;             /*input高度*/
  width: 20vw;                  /*input宽度*/
  background-image: url("../../assets/password.png") ;/*设置图片的地址*/
  background-size:25px 25px;    /*这里是图片的大小*/
  background-repeat:no-repeat ;  /*让图片不重复*/
  background-position: 2vw 5px; /*图片在input中的位置  离左边的距离和离右边的距离*/
  /*border: none;*/
  background-color: rgb(245, 248, 255);
  border-radius: 20px;  /*设置圆角半径*/
  border: 1px solid rgb(245, 248, 255);
  /*去除点击产生的黑框*/
  outline: none;
  padding-left: calc(4vw + 15px);
  margin-top: 4vh;
}
.btn{
width: 25vw;
  height: 72px;
  background-color: #1487CB;
  border: none;
  border-radius: 20px;
  margin-top: 5vh;

}

</style>



// WEBPACK FOOTER //
// src/views/login/index.vue